<template>
  <div class="map_wrap">
    <div id="mask" :class="chunjingData ? 'active' : ''"></div>
    <div class="show_layer_btn" @click="baseInfoLayer">
      <i class="iconfont">&#xe752;</i>
    </div>
    <transition name="opac">
      <div class="map_layer" v-if="!map_complete"></div>
    </transition>
    <div class="map" id="map"></div>
    <div class="org_search" :class="{ 'trans-X': chunjingData }">
      <input
        type="text"
        placeholder="请选择单位信息"
        :value="selectDepartName"
        readonly="readonly"
        @click="selectOrg()"
      />
    </div>

    <div
      class="l_layer"
      @click="switchPointer"
      :class="{ active: !markerStage }"
    >
      <img
        :src="markerStage ? closeImg : openImg"
        alt=""
        style="width: 24px; margin-right: 5px"
      />
      <span :class="{ dp_fs_color: markerStage }">{{
        markerStage ? "全部" : "聚合"
      }}</span>
    </div>
    <div
      class="lk_layer"
      @click="setTrafficLayer"
      :class="{ active: isTraffic }"
    >
      <img :src="traOn" alt="" /> <span class="dp_fs_color"> 实时路况 </span>
    </div>
    <div
      class="wx_layer"
      @click="setWeiXing"
      :class="{ active: wxlayerStatus }"
    >
      <img :src="wxOn" alt="" /> <span class="dp_fs_color"> 卫星 </span>
    </div>
    <div class="to3d dp_fs_color" @click="set3d" :class="{ active: status3d }">
      <img :src="img_2d" alt="" /> <span> {{ text3d }} </span>
    </div>

    <left-list
      :themeStatus="themeStatus"
      :chunjing="chunjingData"
      :headSetaData="headSetaData"
      @left_bot="left_bot"
      @left_top="left_top"
      @left_mid="left_mid"
    ></left-list>
    <right-list
      :themeStatus="themeStatus"
      :chunjing="chunjingData"
      :headSetaData="headSetaData"
      @right_top="right_top"
      @right_mid="right_mid"
      @right_bot="right_bot"
    ></right-list>
    <bottom-list
      ref="bottomListRefs"
      :bot_song_status="bot_song_status"
      :show_bot_trueData="show_bot_trueData"
      :chunjing="chunjingData"
      @markerStatus="setMarker"
      @companyStatus="companyClick"
      @baojing_tanchuang="baojing_tanchuang_init"
      @map-r-b-click="mapRBClick"
      :click_get_data="click_get_data"
      :yuInfo="yuInfo"
      @upDate="upDate"
    ></bottom-list>
    <top-left-list
      :chunjing="chunjingData"
      :markerClick="markerClickStatus"
      :topDate="topDate"
      @mapInterface="mapInterface"
    ></top-left-list>
    <top-right-list
      :chunjing="chunjingData"
      :markerClick="markerClickStatus"
      :topDate="topDate"
    ></top-right-list>
    <div class="remote-control" v-if="remoteControlStatus">
      <remote-control
        v-if="remoteControlStatus"
        @closeUpDate="closeUpDate"
        :orgId="activeOrgId"
        :moduleId="activeDeviceId"
        :controllerNum="activeControllerNum"
        :deviceName="activeDeviceName"
      ></remote-control>
    </div>
    <div
      class="infoLayer"
      v-if="infoLayerStatus"
      :class="{ closeLayerActive: layerCloseStatus }"
      :style="layerCloseStatus ? layerClosePosition : ''"
    >
      <div class="infoLayer_ani">
        <img
          :src="close"
          alt=""
          @click="closeInfoLayer"
          class="infoLayer_close_btn"
        />
        <p class="infoLayerTitle">
          <span> {{ warnTit }}信息 </span>
        </p>
        <ul class="infoLayerUl">
          <li v-if="baojingXinxiBoxData.alarmTime != undefined">
            <span class="infoLayerLeftName"> {{ warnTit }}时间： </span>
            <span class="infoLayerRightValue">
              {{ baojingXinxiBoxData.alarmTime }}
            </span>
          </li>
          <li class="dw_list">
            <span class="infoLayerLeftName"> 单位名称： </span>
            <span class="infoLayerRightValue">
              {{ baojingXinxiBoxData.orgName }}
            </span>
            <img
              :src="marker_dw"
              class="marker_dw_btn"
              alt=""
              @click="setBaojingMark"
            />
            <img
              :src="marker_dt"
              class="marker_dw_btn"
              alt=""
              @click="
                showDtMark(
                  baojingXinxiBoxData.deviceId,
                  baojingXinxiBoxData.cid,
                  baojingXinxiBoxData.buildingId,
                  baojingXinxiBoxData.floor,
                  baojingXinxiBoxData.mapPosition,
                  baojingXinxiBoxData.mapPositionCrt,
                  baojingXinxiBoxData.sourceType,
                  baojingXinxiBoxData.partId,
                )
              "
              v-if="
                baojingXinxiBoxData.mapPosition ||
                  baojingXinxiBoxData.mapPositionCrt
              "
              style="margin-left: 15px"
            />
            <!--<img :src="marker_dt" class="marker_dw_btn" alt="" @click="showDtMark(baojingXinxiBoxData.deviceId,baojingXinxiBoxData.cid,baojingXinxiBoxData.buildingId,baojingXinxiBoxData.floor)" v-if="baojingXinxiBoxData.deviceId" style="margin-left: 15px">-->
          </li>
          <li class="mb_list">
            <span class="infoLayerLeftName"> 目标名称： </span>
            <span class="infoLayerRightValue">
              {{ baojingXinxiBoxData.targetName }}
            </span>
            <div
              class="mubiao_ico"
              v-if="
                baojingXinxiBoxData.cameras || baojingXinxiBoxData.file_path
              "
            >
              <img
                :src="mubiao_shipin"
                alt=""
                class="mb_shipin"
                @click="ico_shipin_click"
                v-if="baojingXinxiBoxData.cameras"
              />
              <img
                :src="mubiao_plan"
                alt=""
                class="mb_plan"
                @click="ico_plan_click"
                v-if="baojingXinxiBoxData.file_path"
              />
              <!--<img :src="mubiao_3d" alt="" class="mb_3d" @click="ico_3d_click" v-if="ico_3d_status">-->
            </div>
          </li>
          <li>
            <span class="infoLayerLeftName"> {{ warnTit }}内容： </span>
            <span class="infoLayerRightValue">
              {{ baojingXinxiBoxData.content }}
            </span>
          </li>
          <li>
            <span class="infoLayerLeftName"> 负责人信息： </span>
            <span class="infoLayerRightValue">
              {{ baojingXinxiBoxData.chargeName }}
              {{ baojingXinxiBoxData.chargeTel }}
            </span>
            <Button
              type="error"
              style="float: right"
              @click="policeSituationHandling(baojingXinxiBoxData)"
              >警情处置</Button
            >
          </li>
          <!-- <li class="time_li">
            <span class="infoLayerLeftName">
              响应时间：
            </span>
            <span class="infoLayerRightValue">
              <i class="len"></i>
            </span>
          </li>
          <li class="time_li">
            <span class="infoLayerLeftName">
              反馈时间：
            </span>
            <span class="infoLayerRightValue">
              <i class="len"></i>
            </span>
          </li> -->
        </ul>
        <!-- <img
          :src="dianhua_img"
          alt=""
          class="infolayer_dianhua_img"
        > -->
      </div>

      <div
        class="ico_shipin_layer"
        v-if="mubiao_shipin_status && baojingXinxiBoxData.cameras"
      >
        <div class="video-title">
          <div>{{ videoName }}</div>
          <div class="video-btn" v-if="videoTotal > 1">
            <img
              v-if="videoIndex > 0"
              style="cursor: pointer"
              @click="videoClick('prev')"
              src="@/assets/images/videoControl/zuo.png"
              alt=""
            />
            <img v-else src="@/assets/images/videoControl/zuo1.png" alt="" />
            <img
              v-if="videoIndex + 1 < videoTotal"
              style="margin-left: 15px; cursor: pointer"
              src="@/assets/images/videoControl/you.png"
              @click="videoClick('next')"
              alt=""
            />
            <img
              v-else
              style="margin-left: 15px"
              src="@/assets/images/videoControl/you1.png"
              alt=""
            />
          </div>
        </div>
        <videoPlay
          v-if="showVideo2"
          :previewUrl="videoSrc"
          :videoDeviceId="videoDeviceId"
          :videoId="993"
          :channelNum="channelNum"
          :videoSid="videoSid"
          :height="370"
          @hideClose="videoSrc = ''"
          :width="450"
          :showClose="false"
        />
        <div v-else style="height: 350px"></div>
        <div class="mubiao_close" @click="ico_shipin_close">
          <img :src="close" alt="" />
        </div>
      </div>
      <div
        class="ico_plan_layer"
        v-if="mubiao_plan_status && baojingXinxiBoxData.file_path"
      >
        <img :src="baojingXinxiBoxData.file_path" alt="" />
        <div class="mubiao_close" @click="ico_plan_close">
          <img :src="close" alt="" />
        </div>
      </div>
      <div class="ico_3d_layer" v-if="mubiao_3d_status">
        <iframe :src="iframeSrc1"></iframe>
        <div class="mubiao_close" @click="ico_3d_close">
          <img :src="close" alt="" />
        </div>
      </div>
    </div>
    <audio
      v-show="audioSrc"
      :src="audioSrc"
      autoplay="autoplay"
      loop="loop"
      ref="audio"
    ></audio>
    <audio
      v-show="bd_audio"
      :src="bd_audio"
      autoplay="autoplay"
      loop="loop"
    ></audio>

    <!-- 单位弹窗 -->
    <div
      class="company_list tuli_layer_bg dp_fs_color"
      v-if="tuliStatus"
      :style="{ 'z-index': company_list_index }"
    >
      <span class="close_span">
        <img :src="newClose" alt="" @click="close_company_list" />
      </span>
      <div class="tit">
        <span class="company_name"> 单位名称 </span>
        <span class="event_count">
          {{
            tuliIndex == 2
              ? "当前报警数"
              : tuliIndex == 3
              ? "当前故障数"
              : tuliIndex == 4
              ? "离线时间"
              : tuliIndex == 1
              ? "当前预警数"
              : tuliIndex == 5
              ? "当前火警数"
              : "当前火警数"
          }}
        </span>
      </div>
      <div class="map_list_wrap">
        <ul>
          <li
            :class="[show_bot_trueData.id == item.id ? 'active' : '']"
            v-for="(item, index) in listLayer_nav_arr"
            :key="index"
            @click="tuli_layer_click(item.id)"
          >
            <span class="company_name"> {{ item.name }} </span>
            <span class="event_count">
              {{
                tuliIndex == 4
                  ? timestampToTime(item.updateTime)
                  : item.eventCount
              }}
            </span>
          </li>
        </ul>
      </div>
      <div class="list_nav" v-if="listLayer_nav_arr.length > 0">
        <ul class="list_nav_ul">
          <!-- <li v-for="(item, index) in list_nav_arr" :key="index" @click="company_list_show(item)" :class="tuli_layer_nav_value == item? 'active': ''">
             {{item}}
           </li>-->
        </ul>
      </div>

      <!-- <div class="more_data_wrap" v-show="botNoData">
        <span class="dp_fs_color">
            更多历史警情信息，请前往告警管理查询。
        </span>
        <div class="more_data_btn">
            <span class="go_search" @click="goSearch">
                前往查询
            </span>
            <span class="cancel" @click="botNoData = false">
                取消
            </span>
        </div>
      </div> -->
    </div>
    <listLayer
      :layerData="layerData"
      @loadMore="loadMore"
      @timeType="timeType"
      @dw_reportData="dwReportLayer"
      @closeLayer="closeListLayer"
      v-show="fengxianStatus"
      :style="{ 'z-index': layer_wrap_index }"
    ></listLayer>
    <departLayer
      :showStatus="selectDepartName"
      :layerData="departListData"
      @loadMore="loadMoreDepart"
      @departData="selectDepart"
      @closeLayer="closeDepartLayer"
      @departName="searchDepart"
      v-show="departListStatus"
      :style="{ 'z-index': depart_wrap_index }"
    >
    </departLayer>
    <div
      class="report_wrap mCustomScrollbar"
      v-show="reportStatus"
      :style="{ 'z-index': fx_z_index }"
    >
      <i class="iconfont close_btn" @click="closeDetailLayer">&#xe664;</i>
      <report :reportData="reportData"></report>
    </div>

    <iframe
      class="map-iframe"
      :src="iframeSrc"
      width="100"
      height="30"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      scrolling="no"
      allowtransparency="yes"
      v-if="isShowIf"
    ></iframe>
    <img
      :src="close"
      alt=""
      class="close_If"
      @click="closeIf"
      v-if="isShowIf"
    />
    <!-- 基础信息左侧列表 -->
    <transition name="trans_left">
      <base-layer-list v-if="showLayer_list"></base-layer-list>
    </transition>
    <!-- 基础信息右侧详情 -->
    <transition name="trans_right">
      <base-layer-detail v-if="showLayer_detail"></base-layer-detail>
    </transition>

    <!-- 视频墙 -->
    <transition name="trans_bottom">
      <video-wall v-if="showVideo" @shipinStatus="setShipin"></video-wall>
    </transition>

    <!-- 从下向上弹窗模板 -->
    <layer-tem></layer-tem>
    <!-- 周边资源弹窗 -->
    <surroundingResources
      v-if="surroundingResourcesShowModal"
      :surroundingResourcesObj="surroundingResourcesObj"
      @up-data-fn="upDataFn"
      @get-this-position="getThisPosition"
      ref="surroundingResourcesRef"
    >
    </surroundingResources>
  </div>
</template>
<script>
import report from "./risk-report.vue";
import listLayer from "@/components/listLayer.vue";
import departLayer from "@/components/departLayer.vue";
import { themeArr } from "@/assets/js/theme.js";
//报警弹窗定位按钮
import marker_dw from "@/assets/img/marker_dingwei.png";
import marker_dt from "@/assets/img/ditu1.png";
import layer_bj from "@/assets/img/bj_layer.png";
import layer_yj from "@/assets/img/yj_layer.png";
import layer_gz from "@/assets/img/gz_layer.png";

import videoPlay from "./videoPlay/videoPlay.vue";

import mubiao_shipin from "@/assets/img/mubiao_shipin.png";
import mubiao_plan from "@/assets/img/mubiao_plan.png";
import mubiao_3d from "@/assets/img/mubiao_3d.png";

import dianhua_img from "@/assets/img/dianhua.png";
import leftList from "@/components/leftList.vue";
import rightList from "@/components/rightList.vue";
import bottomList from "@/components/bottomList.vue";
import topLeftList from "@/components/topLeftList.vue";
import topRightList from "@/components/topRightList.vue";
import remoteControl from "@/components/remote-control/remote-control.vue";
import surroundingResources from "./surrounding-resources.vue";
import nav from "@/assets/img/nav.png";
import close from "@/assets/img/close.png";
import close_la from "@/assets/img/close_la.png";
import newClose from "@/assets/img/newClose.png";
import audio from "@/assets/audio/song.mp3";
import traOn from "@/assets/img/traOn.png";
import traOff from "@/assets/img/traOff.png";
import wxOn from "@/assets/img/weixingon.png";
import wxOff from "@/assets/img/weixingoff.png";
import to2d from "@/assets/img/3d.png";
import to3d from "@/assets/img/2d.png";

//获取地图上图标接口
import {
  tuli_click,
  tubiaoInit,
  tubiaoInitLeft,
  tubiaoInitLeftDetail,
  danweiList_click,
  layer_data,
  personData,
  tuisong_btn,
  fengxian_report,
  getDepartList,
  building_map_conf,
} from "@/assets/js/url.js";

// 随机字符串
import { getTime } from "@/assets/js/index";

//引入video.js
import videojs from "video.js";
import "videojs-contrib-hls";

import baojing_img from "@/assets/img/baojing_img.png";

import { get_voice_broadcast } from "@/assets/js/bdaudio.js";
import marker0Img from "@/assets/marker/alarm.png"; //报警
import marker0 from "@/assets/marker/3.png"; //报警
import marker1Img from "@/assets/marker/frie.png"; //火警
import marker1 from "@/assets/marker/2.png"; //火警
import marker2Img from "@/assets/marker/ico2.png"; //故障
import marker2 from "@/assets/marker/5.png"; //故障
import marker3Img from "@/assets/marker/ico3.png"; //正常
import marker3 from "@/assets/marker/6.png"; //正常
import marker4Img from "@/assets/marker/ico4.png"; //离线
import marker4 from "@/assets/marker/1.png"; //离线
import marker5Img from "@/assets/marker/ico5.png"; //预警
import marker5 from "@/assets/marker/4.png"; //预警

import openImg from "@/assets/marker/open.png"; //预警
import closeImg from "@/assets/marker/close.png"; //预警

import markerImgLeft1 from "@/assets/marker/icon_weixianpin.png";
import markerImgLeft2 from "@/assets/marker/icon_jiayouzhan.png";
import markerImgLeft3 from "@/assets/marker/icon_shuiyuan.png";
import markerImgLeft4 from "@/assets/marker/icon_churukou.png";
import markerImgLeft5 from "@/assets/marker/icon_binan.png";
import markerImgLeft6 from "@/assets/marker/icon_xiangao.png";
import markerImgLeft7 from "@/assets/marker/icon_xiaofangzhan.png";

// 业主基础信息
import baseLayerList from "@/components/base-layer-list.vue";
import baseLayerDetail from "@/components/base-layer-detail.vue";
import videoWall from "@/components/video-wall.vue";
import layerTem from "@/components/layer/layer-tem.vue";
import Bus from "@/assets/api/Bus";
export default {
  name: "",
  data: () => ({
    marker0Img,
    marker1Img,
    marker2Img,
    marker3Img,
    marker4Img,
    marker5Img,
    marker0,
    marker1,
    marker2,
    marker3,
    marker4,
    marker5,
    openImg,
    closeImg,
    warnTit: "报警",
    isShowIf: false,
    iframeSrc: "",
    iframeSrc1: "",
    baojing_id: "", //报警坐标，控制地图上单位坐标置顶
    marker_dw: marker_dw,
    marker_dt: marker_dt,
    click_get_data: {},
    map_complete: false, //map加载状态
    bd_audio: "", //百度语音
    bd_audio_init: "", //初始化百度语音
    close_la: close_la,
    newClose: newClose,
    layer_bj: layer_bj,
    layer_yj: layer_yj,
    layer_gz: layer_gz,
    baojing_img: baojing_img,
    mubiao_shipin: mubiao_shipin,
    mubiao_plan: mubiao_plan,
    mubiao_3d: mubiao_3d,

    //视频弹窗 状态
    mubiao_shipin_status: false,
    //图片弹窗 状态
    mubiao_plan_status: false,
    //3d地图弹窗 状态
    mubiao_3d_status: false,
    dianhua_img: dianhua_img,
    // to2d: to2d,
    img_2d: themeArr[0].to2d,
    to2d: themeArr[0].to2d,
    to3d: themeArr[0].to3d,
    mapStyle: themeArr[0].map,
    status3d: false,
    text3d: "3D",
    wxOn: themeArr[0].weixing,
    wxOff: wxOff,
    audioSrc: "",
    baojingXinxiBoxData: {},
    infoLayerStatus: false, //弹窗状态
    layerCloseStatus: false, //弹窗关闭状态
    layerClosePosition: {
      left: "790px",
      bottom: "-100px",
      marginLeft: 0,
      marginTop: 0,
    },
    baojinglistLeft: "",
    close: close,
    nav: nav,
    map: "",
    // driving: '',
    markerObj: {},
    markerObjLeft: {},
    marker: "",
    markerClickStatus: false,
    shengyinStatus_sum: true, //true 关闭声音开关，false 打开声音开关,
    showVideo: false,
    qidianPoint: [], //根据ip地址获取到当前经纬度
    //echarts 左右图标变量
    echart_left_top: "",
    echart_left_mid: "",
    echart_left_bot: "",

    echart_right_top: "",
    echart_right_mid: "",
    echart_right_bot: "",
    trafficLayer: "", //路况图层
    isTraffic: false,
    traOn: themeArr[0].lukuang,
    traOff: traOff,
    wxlayer: "",
    wxlayerStatus: false,
    getPitch: 0,
    hashValue: "",
    loginData: "",
    tuliIndex: 0,
    tuliStatus: false,
    show_bot_trueData: {},
    // botNoData: false,
    listLayer_nav_arr: [],
    list_nav_arr: [],
    bot_song_status: true, //打开声音
    yuInfo: "", //预警信息

    tuli_layer_count: 0,
    tuli_layer_nav_value: 1, //导航点击值
    lunxun_timer: null,
    nativeClick: false,
    markerStage: false,
    layerData: "",
    departListData: "",
    layer_currentPage: 1, //弹窗分页索引
    loadMoreStatus: false,
    departLoadStatus: false,
    dataType: "week",
    fengxianStatus: false,
    fx_z_index: 11, //单位风险指数详情弹窗层级
    company_list_index: 11, //单位列表弹窗层级
    layer_wrap_index: 11, //单位风险指数排名层级
    depart_wrap_index: 11, //单位列表排名层级
    depart_currentPage: 1,
    depart_pageSize: 50,
    depart_name: null,
    selectDepartName: "",
    departListStatus: false,
    base_index: 11,
    reportStatus: false,
    reportData: null,
    labelsLayer: null,
    cluster: null,
    markerArr: [],
    labelMarkerArr: [],
    topDate: "",
    // audioSrcNew:'@/static/audio/song.mp3',
    videoSrc: "",
    videoDeviceId: "",
    channelNum: "",
    videoSid: "",
    videoName: "",
    showVideo2: false,
    videoIndex: 0,
    videoTotal: "",
    camerasList: [],
    remoteControlStatus: false,
    activeOrgId: "",
    activeDeviceId: "",
    activeControllerNum: "",
    activeDeviceName: "",
    infoWindow: null,
    winInfo: [],
    winTitle: "",
    surroundingResourcesShowModal: false,
    surroundingResourcesObj: {},
    canvasLayer: null,
  }),
  props: [
    "dingwei",
    "chunjingData",
    "headSetaData",
    "syStatus",
    "themeStatus",
    "fengxian",
    "spStatus",
  ],
  watch: {
    fengxian: function(res) {
      console.log(res);

      if (!this.fengxianStatus) {
        this.dwListLayer();
      } else {
        console.log("已经打开了");
      }
    },
    themeStatus: function(res) {
      console.log("改变主题");

      switch (res) {
        case 0: //湖蓝色
          this.img_2d = themeArr[1].to2d;
          this.to2d = themeArr[1].to2d;
          this.to3d = themeArr[1].to3d;
          this.mapStyle = themeArr[1].map;
          this.wxOn = themeArr[1].weixing;
          this.traOn = themeArr[1].lukuang;
          break;
        case 1: //群青色
          this.img_2d = themeArr[0].to2d;
          this.to2d = themeArr[0].to2d;
          this.to3d = themeArr[0].to3d;
          this.mapStyle = themeArr[0].map;
          this.wxOn = themeArr[0].weixing;
          this.traOn = themeArr[0].lukuang;
          break;
      }
      //设置地图样式
      this.map.setMapStyle(this.mapStyle);
    },
    dingwei: function(res) {
      //点击定位按钮，定位到当前位置
      this.getThisPosition();
    },
    // 声音开关
    syStatus: function(res) {
      this.shengyinStatus_sum = !this.shengyinStatus_sum;
      if (this.shengyinStatus_sum) {
        if (this.infoLayerStatus) {
          this.audioSrc = audio;
          this.bd_audio = this.bd_audio_init;
        }
        //允许预警弹窗打开声音，具体根据数据情况决定
        this.bot_song_status = {
          type: true,
          date: new Date(),
        };
      } else {
        this.audioSrc = "";

        this.bd_audio = "";
        //关闭预警弹窗声音
        this.bot_song_status = {
          type: false,
          date: new Date(),
        };
      }
    },

    // 视频墙
    spStatus: function(res) {
      this.showVideo = res;
    },
  },
  components: {
    leftList,
    rightList,
    bottomList,
    videoPlay,
    topLeftList,
    topRightList,
    surroundingResources,
    remoteControl,
    listLayer,
    departLayer,
    report,
    baseLayerList,
    baseLayerDetail,
    videoWall,
    layerTem,
  },
  beforeDestroy() {
    clearInterval(this.lunxun_timer);
    if (this.map) {
      this.map.destroy(); // 销毁地图实例，释放资源
    }
  },
  created() {
    Bus.$on("topDate", (val) => {
      this.topDate = val;
    });
    // this.getMqttUrl();
  },
  async mounted() {
    // clearInterval(this.lunxun_timer);
    let that = this;
    await this.loadScript();
    this.hashValue = window.localStorage.getItem("hashValue");
    this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
    this.$nextTick(() => {
      that.mapInit();
    });
    setInterval(() => {
      that.mapInit();
    }, 1000 * 60 * 30); // 每30分钟执行一次
    this.lunxun();
    setTimeout(() => {
      window.onresize = function() {
        if (that.echart_left_top) {
          that.echart_left_top.resize();
        }
        if (that.echart_left_mid) {
          that.echart_left_mid.resize();
        }
        if (that.echart_left_bot) {
          that.echart_left_bot.resize();
        }
        if (that.echart_right_top) {
          that.echart_right_top.resize();
        }

        if (that.echart_right_mid) {
          that.echart_right_mid.resize();
        }
        if (that.echart_right_bot) {
          that.echart_right_bot.resize();
        }

        //初始化滚动条
        $JQ(".mCustomScrollbar").mCustomScrollbar();
      };
    }, 200);
  },
  computed: {
    showLayer_list() {
      return this.$store.state.baseInfoLayer.listStatus;
    },
    showLayer_detail() {
      return this.$store.state.baseInfoLayer.detailStatus;
    },
    showLayer() {
      return this.$store.state.showLayer.status;
    },
  },
  methods: {
    setShipin(val) {
      this.showVideo = val;
    },
    baseInfoLayer() {
      //左侧单位列表弹窗显示
      this.$store.commit("baseInfoLayer", {
        listStatus: true,
      });
    },
    goSearch() {
      const loginname = JSON.parse(window.localStorage.getItem("loginData"))
        .loginName;
      const pwdHash = window.localStorage.getItem("hashValue");
      open(
        `http://zsv.ayy123.com/#/login?user_phone=${loginname}&user_token=${pwdHash}`,
      );
    },
    closeDepartLayer() {
      this.selectDepartName = "";
      this.departListStatus = false;
      this.depart_wrap_index = 11;
      this.depart_currentPage = 1;
    },
    selectOrg() {
      this.departListStatus = true;
      // if(this.markerClickStatus){ //如果单位详情谈窗打开
      this.base_index += 1;
      this.depart_wrap_index = this.base_index;
      // }
      //获取单位列表
      var data = {
        type: "get",
        url: getDepartList,
        obj: {
          // orgId,
          currentPage: this.depart_currentPage,
          pageSize: this.depart_pageSize,
          name: this.depart_name,
        },
      };
      this.$Axios(data).then((res) => {
        console.log(res);
        console.log("单位列表");
        this.departLoadStatus = false;
        if (res.data.success) {
          this.departListData = res.data;
        }
      });
    },
    searchDepart(name) {
      //搜索单位名称
      console.log(name); //每次搜索，需要重置currentPage
      console.log("单位名称");
      if (name) {
        this.depart_name = name;
      } else {
        this.depart_name = null;
      }
      this.depart_currentPage = 1;
      this.selectOrg();
    },
    loadMoreDepart(res) {
      //加载更多单位列表数据
      console.log(res);
      if (this.departLoadStatus) {
        //如果正在加载中，禁止多次请求
        return;
      } else {
        this.departLoadStatus = true;
        this.depart_currentPage++;
        this.selectOrg();
      }
    },
    selectDepart(departData) {
      //点击列表，显示原生弹窗
      // console.log(departData);
      let position = departData.position.split(","); //坐标
      this.selectDepartName = departData.name; //name
      let data = `${departData.onlineState == 1 ? "已联网" : "未联网"}_${
        departData.address
      }_${departData.industryCategoryName}_${
        departData.supervisionLevelName
      }_${getTime(departData.createTime, "day", "sel")}_${
        departData.leaderPhone
      }_${departData.leaderPhone}_null_null_null_null_${departData.areaName}`;
      let orgId = departData.orgId; //orgId
      this.depart_wrap_index = 11;
      this.nativeLayer(position, this.selectDepartName, data, orgId);

      // var data = {
      //     type: 'get',
      //     url: tubiaoInit,
      //     obj: {
      //         orgId,
      //         // currentPage: this.depart_currentPage,
      //         // pageSize: this.depart_pageSize,
      //         // name: this.depart_name,
      //     }
      // };
      // this.$Axios(data).then((res)=>{
      //     console.log(res);
      //     console.log('点击获取单位列表');
      // });
      // 显示原生弹窗
    },
    closeListLayer() {
      this.fengxianStatus = false;
      this.reportStatus = false;
      this.layer_wrap_index = 11; //单位风险弹窗层级
      this.fx_z_index = 11; //单位风险详情弹窗层级
    },
    closeDetailLayer() {
      this.reportStatus = false;
      this.fx_z_index = 11; //单位风险详情弹窗层级
    },
    dwReportLayer(data) {
      //单位风险列表弹窗
      this.reportStatus = true;
      this.reportData = data;
      // if(this.markerClickStatus){ //如果单位详情谈窗打开
      this.base_index += 1;
      this.fx_z_index = this.base_index;
      // }
    },
    dwListLayer() {
      //显示单位弹窗
      var orgId = this.loginData.orgId;
      var data = {
        type: "get",
        url: fengxian_report,
        obj: {
          date: this.dataType,
          sort: "DESC",
          currentPage: this.layer_currentPage,
          pageSize: 50,
          orgId: orgId,
        },
      };

      this.$Axios(data).then((res) => {
        console.log(res);
        console.log("加载单位排名数据");

        this.layerData = res;
        //重置加载开关
        this.loadMoreStatus = false;
        this.fengxianStatus = true;
        console.log(this.markerClickStatus);

        // if(this.markerClickStatus){ //如果单位弹窗显示，则设置此弹窗z-index比单位弹窗z-index大
        this.base_index += 1;
        this.layer_wrap_index = this.base_index;
        // }
      });
    },
    loadMore(res) {
      if (this.loadMoreStatus) {
        //如果正在加载中，禁止多次请求
        return;
      } else {
        this.loadMoreStatus = true;
        this.layer_currentPage++;
        this.dwListLayer();
      }
    },
    timeType(res) {
      this.reportStatus = false;
      if (this.loadMoreStatus) {
        //如果正在加载中，禁止多次请求
        return;
      } else {
        this.dataType = res;
        this.loadMoreStatus = true;
        this.layer_currentPage = 1;
        this.dwListLayer();
      }
    },
    //报警弹窗，点击定位按钮，缩放到报警图标并且置顶该图标
    setBaojingMark() {
      console.log(this.baojing_id);
      //找到这个坐标，直接定位到该位置，然后置顶。
      for (let i = 0; i < this.labelMarkerArr.length; i++) {
        if (this.labelMarkerArr[i].getExtData().orgId == this.baojing_id) {
          console.log(i);
          //置顶该坐标
          this.labelMarkerArr[i].setTop(true);
          var mark_data = this.labelMarkerArr[i].getExtData(); // 获取该图标数据
          break;
        }
      }
      //定位到图标的坐标
      this.getThisPosition(mark_data.pos);
      //弹出单位信息弹窗
      this.nativeLayer(
        mark_data.pos,
        mark_data.name,
        mark_data.data,
        mark_data.orgId,
      );
    },

    //点击报警弹窗上三维地图
    showDtMark(
      deviceId,
      cid,
      buildingId,
      floor,
      mapPosition,
      mapPositionCrt,
      sourceType,
      partId,
    ) {
      if (mapPosition) {
        var data = {
          type: "get",
          url: building_map_conf + buildingId,
          obj: {},
        };
        this.$Axios(data).then((res) => {
          this.mubiao_3d_status = true;
          this.iframeSrc1 =
            "http://fmap.ayy123.com/show.html?appCode=runWatchScreen&orgId=" +
            cid +
            "&phone=" +
            this.loginData.loginName +
            "&pass=" +
            window.localStorage.getItem("hashValue") +
            "&deviceId=" +
            deviceId +
            "&buildingId=" +
            res.data.data.buildingId +
            "&defaultThemeName=" +
            res.data.data.styleId +
            "&fmapID=" +
            res.data.data.mapId +
            "&devicebNum=" +
            deviceId +
            "&floor=" +
            floor +
            "&token=" +
            window.localStorage.getItem("randVal_token");
          console.log(this.iframeSrc1);
        });
      } else if (mapPositionCrt) {
        this.mubiao_3d_status = true;
        let deviceIds;
        sourceType == 0 ? (deviceIds = deviceId) : (deviceIds = partId);
        this.iframeSrc1 =
          window.localStorage.getItem("crt_url") +
          "/crt-track?orgName=" +
          this.loginData.orgName +
          "&orgId=" +
          cid +
          "&phone=" +
          this.loginData.loginName +
          "&pass=" +
          window.localStorage.getItem("hashValue") +
          "&appCode=runWatchScreen" +
          "&token=" +
          window.localStorage.getItem("randVal_token") +
          "&buildingId=" +
          buildingId +
          "&floor=" +
          floor +
          "&sourceType=" +
          sourceType +
          "&deviceId=" +
          deviceIds +
          "&schema=2";
      } else {
        this.$message({
          message: "暂无地图信息",
          type: "warning",
        });
      }
    },
    lunxun() {
      //为了防止掉线，这里每隔一段时间请求一下接口，激活当前用户状态
      let sum = 0;
      let limit = 1000 * 60 * 25;
      clearInterval(this.lunxun_timer);
      this.lunxun_timer = setInterval(() => {
        sum += 25;
        console.log(sum + "分钟");
        //请求所属区域信息
        var data = {
          type: "get",
          url: personData,
          obj: {},
        };
        this.$Axios(data).then((res) => {
          console.log(res);
          console.log("每隔25分钟请求一次数据");
          if (!res.data.success) {
            console.log("已经掉线了");
            this.$router.replace({ name: "login" });
          }
        });
      }, limit);
    },
    timestampToTime(timestamp) {
      if (timestamp == undefined) {
        return "";
      } else {
        var date = new Date(timestamp); //时间戳 -- 如果date为13位不需要乘1000  3-11修改
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
    videoInit(str) {
      console.log(str);
      console.log("-----初始化视频播放-");
      var videoPlayer = $("#" + str).get(0);
      console.log(videoPlayer);

      if (typeof videoPlayer == "undefined") {
        var myPlayer = videojs(str, {
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: true,
          errorDisplay: false,
          controlBar: true,
        });
      } else {
        console.log("初始化失败");
      }
      this.videoPlay(str);
    },
    videoPlay(str) {
      var str = videojs(str);
      setTimeout(() => {
        str.play();
      }, 200);
    },
    videoDispose(str) {
      console.log(str);
      console.log("-----视频销毁");

      var videoPlayer = $("#" + str).get(0);
      console.log(videoPlayer);

      if (typeof videoPlayer != "undefined") {
        var myPlayer = videojs(str);
        myPlayer.dispose();
        this.mubiao_shipin_status = false;
      } else {
        console.log("销毁失败");
      }
    },
    ico_shipin_close() {
      //关闭视频弹窗
      // setTimeout(() => {
      //     this.videoDispose('ico_video');
      // }, 200);
      this.mubiao_shipin_status = false;
    },
    ico_plan_close() {
      //关闭图片弹窗
      this.mubiao_plan_status = false;
    },
    ico_3d_close() {
      //关闭3d地图弹窗
      this.mubiao_3d_status = false;
    },
    //点击视频图标，显示视频
    ico_shipin_click() {
      // this.mubiao_shipin_status = true;
      // setTimeout(() => {
      //   this.videoInit("ico_video");
      // }, 200);
      console.log(this.baojingXinxiBoxData.cameras);
      if (
        this.baojingXinxiBoxData.cameras &&
        this.baojingXinxiBoxData.cameras.length > 0
      ) {
        this.videoTotal = this.baojingXinxiBoxData.cameras.length;
        this.camerasList = this.baojingXinxiBoxData.cameras;
        this.videoSrc = this.camerasList[this.videoIndex].hlsAddr;
        this.videoDeviceId = this.camerasList[this.videoIndex].id;
        this.channelNum = this.camerasList[this.videoIndex].channelNum;
        this.videoSid = this.camerasList[this.videoIndex].num;
        this.videoName = this.camerasList[this.videoIndex].name;
        this.mubiao_shipin_status = true;
        this.showVideo2 = false;
        setTimeout(() => {
          this.showVideo2 = true;
        }, 300);
      }
    },
    //点击图片图标，显示图片
    ico_plan_click() {
      this.mubiao_plan_status = true;
    },
    //点击3d地图图标，显示3d地图
    // ico_3d_click(){
    //     this.mubiao_3d_status = true;
    // },
    close_company_list() {
      this.tuliStatus = false;
      this.company_list_index = 11;
      // this.botNoData = false;
      this.show_bot_trueData = {
        show: true,
        data: "",
        type: "",
        id: "",
        date: new Date(),
      };
    },
    company_click_getData() {
      let self = this;
      //点击下面的导航按钮，调取这个方法，一切都以下面的导航按钮为准，因为有总数字段控制，导航按钮数量可以控制
      //图例分页数据
      var orgId = this.loginData.orgId;
      var data = {
        type: "get",
        url: tuli_click,
        obj: {
          eventType: String(this.tuliIndex),
          currentPage: this.tuli_layer_nav_value,
          pageSize: 10,
          orgId: orgId,
        },
      };
      this.$Axios(data).then((res) => {
        if (res.data.success) {
          this.listLayer_nav_arr = [
            ...this.listLayer_nav_arr,
            ...res.data.data,
          ];
          this.$nextTick(() => {
            $JQ(".map_list_wrap").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function() {
                  if (self.listLayer_nav_arr.length == res.data.totalCount) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    self.tuli_layer_nav_value += 1;
                    self.company_click_getData();
                  }
                },
              },
            });
          });
        }
      });
    },
    //图例点击事件
    companyClick(res) {
      /*
      图例点击传过来的数据
      分页，默认都是第一页数据，这里再增加分页数据
      */

      //初始化导航值为1
      this.tuli_layer_nav_value = 1;

      //初始化导航数组
      this.listLayer_nav_arr = [];
      // this.list_nav_arr = [];

      //弹窗头部文字判断显示
      this.tuliIndex = res;
      //弹窗显示状态
      this.tuliStatus = true;
      this.base_index += 1;
      this.company_list_index = this.base_index;

      this.company_click_getData();
    },
    left_top(res) {
      this.echart_left_top = res;
    },
    left_mid(res) {
      this.echart_left_mid = res;
    },
    left_bot(res) {
      this.echart_left_bot = res;
    },
    right_top(res) {
      this.echart_right_top = res;
    },
    right_mid(res) {
      this.echart_right_mid = res;
    },
    right_bot(res) {
      this.echart_right_bot = res;
    },
    //关闭报警框，并且关闭报警声音
    closeInfoLayer() {
      //关闭报警消息弹窗，三个小图标弹窗全部关闭,不用清空内容，因为每次点击报警列表，内容都会变
      //视频弹窗 状态
      this.mubiao_shipin_status = false;
      //图片弹窗 状态
      this.mubiao_plan_status = false;
      //3d地图弹窗 状态
      this.mubiao_3d_statsu = false;

      //关闭声音
      this.audioSrc = "";

      this.bd_audio = "";
      //这里点击关闭，直接关闭，不用再检索
      this.layerCloseStatus = true;
      setTimeout(() => {
        this.infoLayerStatus = false;
      }, 600);
      this.show_bot_trueData = {
        show: true,
        data: "",
        type: "",
        id: "",
        date: new Date(),
      };
    },
    //底部导航点击，增加marker
    setMarker(res) {
      console.log(res);
      this.baojing_id = res.data.cid;
      console.log(this.baojing_id);
      console.log("底部导航点击");

      //报警单位弹出报警信息
      this.baojingInit(res.data, res.baoOrYu);
      this.layerClosePosition.left = "420px";

      //因为视频需要初始化，所以调用销毁视频事件
      this.ico_shipin_close();
      this.ico_plan_close();
      this.ico_3d_close();
    },
    // getMqttUrl() {
    //     return new Promise((resolve, reject) => {
    //         var data = {
    //             type: "get",
    //             url: "/mcbw/file/template_static",
    //             obj: {
    //                 fileKey:"oss_domain"
    //             },
    //         };
    //         this.$Axios(data)
    //         .then((res) => {
    //             if (res.data.success&&res.data.data) {
    //                 this.audioSrcNew="http://"+res.data.data+"/gd-ca/song.mp3"
    //             }
    //         })
    //     });
    // },
    //推送报警信息，显示弹窗
    baojing_tanchuang_init(res) {
      let data = res.data;
      console.log(data, "父组件接收的信息");
      console.log(res.type);
      console.log(res.type == "hj" ? "火警" : "报警");
      if (res.type == "hj") {
        this.warnTit = "火警";
      } else {
        this.warnTit = "报警";
      }

      this.baojing_id = Number(data.id.substring(0, data.id.indexOf("_"))); //和地图上的图标坐标数据对应
      this.layerClosePosition.left = "420px";

      //因为视频需要初始化，所以调用销毁视频事件
      this.ico_shipin_close();
      this.ico_plan_close();
      this.ico_3d_close();
      //报警弹窗弹出内容
      this.baojingXinxiBoxData = {
        alarmTime: data.time,
        orgName: data.companyName,
        targetName: data.tname, //目标名称
        content: data.content,
        chargeName: data.contactName,
        chargeTel: data.contactPhone,
        file_path: "",
        hlsAddr: data.videoAddr,
        cid: data.id.split("_")[0],
        mapPosition: data.mapPosition,
        mapPositionCrt: data.mapPositionCrt,
        floor: data.floor,
        buildingId: data.buildingId,
        deviceId: data.deviceId,
        sourceType: data.sourceType,
        partId: data.partId,
        cameras: data.cameras,
        type: data.type,
        id: data.uuid,
      };

      var type = "";
      var id = "";
      if (data.tid != undefined) {
        type = 1;
        id = data.tid;
      } else if (data.deviceId != undefined) {
        type = 2;
        id = data.deviceId;
      } else if (data.cid != undefined) {
        type = 3;
        id = data.cid;
      } else {
        console.log("接口错误");
      }

      this.tuisong_get_btn(type, id, res.type);

      var loginname = JSON.parse(window.localStorage.getItem("loginData"))
        .loginName;
      //弹出报警框
      console.log(data);
      this.layerCloseStatus = false;
      this.infoLayerStatus = true;
      //火警推送来时，自动播放摄像头
      // if (res.type == "hj") {
      setTimeout(() => {
        this.ico_shipin_click();
      }, 200);
      // }
      if (data.mapPosition) {
        let cid = data.id.split("_")[0];
        this.showDtMark(
          data.deviceId,
          cid,
          data.buildingId,
          data.floor,
          data.mapPosition,
          data.mapPositionCrt,
          data.sourceType,
          data.partId,
        );
      }
      console.log(1465);
      if (this.shengyinStatus_sum) {
        //如果报警声音开关是开着的
        this.audioSrc = audio;
        console.log(1469);
        get_voice_broadcast(this.baojingXinxiBoxData.content).then((res) => {
          this.bd_audio_init = res && res.data ? res.data.trim() : "";
          console.log(this.bd_audio_init, "++++++++");
          this.bd_audio = this.bd_audio_init;
        });
        console.log(data.content);
      } else {
        this.audioSrc = "";

        this.bd_audio = "";
      }
    },
    upDate(dataObj) {
      console.log("dataObjdataObj+++", dataObj);
      this.activeOrgId = dataObj.cid;
      this.activeDeviceId = dataObj.hostId;
      this.activeControllerNum = dataObj.controllerNum;
      this.activeDeviceName = dataObj.hostName;
      this.remoteControlStatus = true;
    },
    baojingInit(result, baoOrYu) {
      var loginname = this.loginData.loginName;
      if (baoOrYu == 2) {
        //预警
        var data = {
          type: "get",
          url: layer_data,
          obj: {
            tid: result.tid ? String(result.tid) : null,
            cid: result.cid ? String(result.cid) : null,
            currentPage: 1,
            pageSize: 1,
            ctime: String(result.ctime),
            alarmType: String(result.type),
            eventType: "1",
          },
        };
      } else if (baoOrYu == 1) {
        //报警
        this.warnTit = "报警";
        var data = {
          type: "get",
          url: layer_data,
          obj: {
            tid: result.tid ? String(result.tid) : null,
            cid: result.cid ? String(result.cid) : null,
            currentPage: 1,
            pageSize: 1,
            ctime: String(result.ctime),
            alarmType: String(result.type),
            eventType: "2",
          },
        };
      } else if (baoOrYu == 0) {
        //火警
        this.warnTit = "火警";
        var data = {
          type: "get",
          url: layer_data,
          obj: {
            tid: result.tid ? String(result.tid) : null,
            cid: result.cid ? String(result.cid) : null,
            currentPage: 1,
            pageSize: 1,
            ctime: String(result.ctime),
            alarmType: String(result.type),
            sources: "3,6,7",
            eventType: "4",
          },
        };
      } else if (baoOrYu == 3) {
        this.warnTit = "故障";
        var data = {
          type: "get",
          url: layer_data,
          obj: {
            tid: result.tid ? String(result.tid) : null,
            cid: result.cid ? String(result.cid) : null,
            currentPage: 1,
            pageSize: 1,
            ctime: String(result.ctime),
            alarmType: String(result.type),
            eventType: "3",
          },
        };
      }
      this.$Axios(data).then((res) => {
        console.log(res);
        console.log("点击报警、预警、故障消息列表，弹出内容");

        if (baoOrYu == 2 || baoOrYu == 3) {
          this.yuInfo = res.data.data;
        } else {
          this.baojingXinxiBoxData = res.data.data;
          this.baojingXinxiBoxData.alarmTime = this.timestampToTime(
            res.data.data.alarmTime,
          );
          this.baojingXinxiBoxData.cid = result.cid;

          //弹出报警框
          this.layerCloseStatus = false;
          this.infoLayerStatus = true;
          if (this.shengyinStatus_sum) {
            //如果报警声音开关是开着的
            this.audioSrc = audio;

            get_voice_broadcast(this.baojingXinxiBoxData.content).then((res) => {
              this.bd_audio_init = res && res.data ? res.data.trim() : "";
              this.bd_audio = this.bd_audio_init;
              console.log(this.bd_audio, this.bd_audio_init, "+++");
            });
            console.log(this.baojingXinxiBoxData.content);
          } else {
            this.audioSrc = "";

            this.bd_audio = "";
          }

          if (res.data.data.cameras) {
            this.ico_shipin_click();
          }
        }
      });
    },
    tuisong_get_btn(type, id, mold) {
      var data = {
        type: "get",
        url: tuisong_btn + type + "/" + id,
        obj: {},
      };
      this.$Axios(data).then((res) => {
        console.log(res);
        console.log(res.data.data.file_path);
        console.log(res.data.data.hlsAddr);

        console.log("报警弹窗推送----获取按钮");
        this.baojingXinxiBoxData.file_path = res.data.data.file_path
          ? res.data.data.file_path
          : "";
        if (mold != "hj") {
          this.baojingXinxiBoxData.hlsAddr = res.data.data.hlsAddr
            ? res.data.data.hlsAddr
            : "";
        }
      });
    },
    mapRBClick(activeItem) {
      let _that = this;
      this.surroundingResourcesShowModal = true;
      this.surroundingResourcesObj = activeItem;
      setTimeout(() => {
        _that.$refs.surroundingResourcesRef.getListData(activeItem);
      }, 100);
    },
    upDataFn(e) {
      this.surroundingResourcesShowModal = e;
    },
    async loadScript() {
      if (!window.AMap) {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src =
            "https://webapi.amap.com/maps?v=1.4.15&key=a82b635119abde7ac5467d9124a48556&plugin=ElasticMarker,AMap.MarkerClusterer,TileLayer";
          script.onload = () => {
            resolve();
          };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      return Promise.resolve();
    },
    //初始化地图
    mapInit(value) {
      let that = this;
      // let position = JSON.parse(window.localStorage.getItem("loginData")).position;
      // let center=[102.820406,24.880067];
      // if(position){
      //   center=[Number(position.split(",")[0]),Number(position.split(",")[1])];
      // }
      that.map = new AMap.Map("map", {
        resizeEnable: true,
        key: "a82b635119abde7ac5467d9124a48556",
        // center: [102.820406,24.880067],
        // zoom: 17,
        zooms: [5.8, 22],
        mapStyle: that.mapStyle,
        pitch: 60,
        viewMode: "3D",
      });
      AMap.plugin(["AMap.Geolocation"], function() {
        //异步同时加载多个插件
        //实时定位到当前登录位置
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: false, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          showButton: false,
          showMarker: false,
          showCircle: false,
          panToLocation: false,
          // buttonPosition:'RB',
        });
        geolocation.getCurrentPosition(function(status, result) {
          if (status == "complete") {
            that.qidianPoint = [
              result.position.getLng(),
              result.position.getLat(),
            ];
            console.log(that.qidianPoint);
            console.log("定位成功，登录者当前实时坐标值");
            // 定位成功后将地图移动到实际位置
            that.map.setZoomAndCenter(15, that.qidianPoint);
          } else {
            console.log("定位失败");
            that.qidianPoint = [
              Number(that.loginData.position.split(",")[0]),
              Number(that.loginData.position.split(",")[1]),
            ];
            // 定位失败时将地图移动到用户设置的位置
            that.map.setZoomAndCenter(15, that.qidianPoint);
          }
        });
      });
      // that.map.on("zoomend", function() {
      //     //放大，缩小事件
      //     // console.log(parseInt(that.map.getZoom()));
      // });
      // that.map.on("moveend", function() {
      //     // console.log("地图移动了");
      // });
      //设置卫星图层层级高于默认图层
      this.wxlayer = new AMap.TileLayer.Satellite({
        zIndex: 100,
      });
      this.map.add(this.wxlayer);
      this.wxlayer.hide(); //默认进来先隐藏
      // 实时路况图层
      this.trafficLayer = new AMap.TileLayer.Traffic({
        zIndex: 10,
      });
      this.map.add(this.trafficLayer); //添加路况图层
      this.trafficLayer.hide(); //默认进来先隐藏
      this.getPitch = this.map.getPitch(); //获取倾斜角
      // 创建 infoWindow 实例
      this.infoWindow = new AMap.InfoWindow({
        content: "", //传入 dom 对象，或者 html 字符串
        offset: new AMap.Pixel(0, 0),
      });
      this.infoWindow.on("close", () => {
        this.markerClickStatus = false;
        this.base_index = 10;
        this.selectDepartName = "";
        this.$emit("departLayer", this.selectDepartName);
        console.log("弹窗关闭");
        if (this.nativeClick) {
          //如果弹窗三个按钮点击了，需要恢复原来的数据，否则不变
          this.nativeClick = false;
          this.close_company_list();
        }
      });
      that.map.on("complete", function() {
        console.log("地图加载完毕");
        // 地图图块加载完成后触发
        that.map_complete = true;
        //获取地图图标数据
        that.getMarkerData(value);
        that.getMarkerDataLeft();
      });
      that.map.on("loaderror", function(e) {
        console.log("地图加载失败", e);
      });
    },

    // 地图接口
    mapInterface(value) {
      this.mapInit(value);
    },

    set3d() {
      this.status3d = !this.status3d;
      if (this.status3d) {
        //转为2d
        this.map.setPitch(1);
        this.img_2d = this.to3d;
        this.text3d = "2D";
      } else {
        //转为3d
        this.map.setPitch(this.getPitch);
        this.img_2d = this.to2d;
        this.text3d = "3D";
      }
    },
    setWeiXing() {
      //添加卫星图层
      if (!this.wxlayerStatus) {
        this.wxlayerStatus = true;
        this.wxlayer.show();
      } else {
        this.wxlayerStatus = false;
        this.wxlayer.hide();
      }
    },
    setTrafficLayer() {
      //添加路况图层
      if (this.isTraffic) {
        this.isTraffic = false;
        this.trafficLayer.hide();
      } else {
        this.isTraffic = true;
        this.trafficLayer.show();
      }
    },
    countPosition(pos, range = 100) {
      //rang 范围
      var position = new AMap.LngLat(pos[0], pos[1]);
      var rightTopPos = position.offset(range, range);
      var leftBotPos = position.offset(-range, -range);
      let obj = {
        leftBot: [leftBotPos.lng, leftBotPos.lat],
        rightTop: [rightTopPos.lng, rightTopPos.lat],
      };
      return obj;
    },
    canvasLayerFn(leftBot, rightTop, color) {
      console.log(leftBot, rightTop, color);
      if (this.canvasLayer) {
        //事先清除图层
        this.canvasLayer.setMap(null);
      }
      var canvas = document.createElement("canvas");
      canvas.width = canvas.height = 200;

      var context = canvas.getContext("2d");
      context.fillStyle = color;
      context.globalAlpha = 1;

      var radious = 0;
      var draw = () => {
        context.clearRect(0, 0, 200, 200);
        context.globalAlpha = (context.globalAlpha - 0.01 + 1) % 1;
        radious = (radious + 1) % 100;

        context.beginPath();
        context.arc(100, 100, radious, 0, 2 * Math.PI);
        context.fill();
        context.stroke();
        this.canvasLayer.reFresh();
        AMap.Util.requestAnimFrame(draw);
      };

      this.canvasLayer = new AMap.CanvasLayer({
        canvas: canvas,
        bounds: new AMap.Bounds(leftBot, rightTop),
        zooms: [3, 18],
        zIndex: 1000, // 设置层级
      });
      console.log(this.canvasLayer);
      this.canvasLayer.setMap(this.map);
      draw();
    },
    //定到当前位置
    getThisPosition(pos, type) {
      console.log(this.qidianPoint, type, "555");
      let _pos = pos ? pos : this.qidianPoint;
      this.map.setZoomAndCenter(17.5, _pos);
      if (type == 2) {
        let bounds = this.countPosition(pos, 50);
        this.canvasLayerFn(bounds.leftBot, bounds.rightTop, "#E44646");
      }
    },

    getMarkerData(value) {
      var orgId = this.loginData.orgId;
      var data = {
        type: "get",
        url: tubiaoInit,
        obj: {
          industryCategory: value,
          orgId,
          currentPage: 1,
          pageSize: 1000,
        },
      };
      this.$Axios(data).then((res) => {
        // console.log(res);
        // console.log('地图图标数据');
        if (res.data.data) {
          this.markerObj = res.data.data;
          const markerLength = Object.keys(this.markerObj).some((item) => {
            return this.markerObj[item].length;
          });
          if (markerLength) {
            // this.addMarkerFun(this.markerObj);
            this.setMarkerPointer(this.markerObj);
          }
        }
      });
    },
    getMarkerDataLeft() {
      var orgId = this.loginData.orgId;
      var data = {
        type: "get",
        url: tubiaoInitLeft,
        obj: {
          orgId,
          currentPage: 1,
          pageSize: 1000,
          types: "1,2,3,4,5,6,7",
        },
      };
      this.$Axios(data).then((res) => {
        if (res.data.data) {
          this.markerObjLeft = res.data.data;
          if (this.markerObjLeft.length > 0) {
            // this.addMarkerFun(this.markerObj);
            this.setMarkerPointerLeft(this.markerObjLeft);
          }
        }
      });
    },
    switchPointer() {
      if (this.markerStage) {
        this.map.remove(this.labelsLayer);
        this.map.setZoom(6, false, 1000);
        this.setMarkerPointer(this.markerObj);
      } else {
        this.cluster.clearMarkers();
        this.addMarkerFun(this.markerObj);
      }

      this.markerStage = !this.markerStage;
    },
    tuli_layer_click(id) {
      //先告诉已经点击了，显示动画等操作
      this.click_get_data = {
        click_get_data: true,
        time: new Date(),
      };
      this.show_bot_trueData = {
        show: false,
        data: null,
        type: this.tuliIndex,
        id: id,
        date: new Date(),
      };
      //该方法用于两个地方
      //1. 点击单位名称
      //2. 点击图标
      //3. 报警弹窗出现
      // var orgId = this.loginData.orgId;
      // var data = {
      //     type: 'get',
      //     url: danweiList_click,
      //     obj: {
      //         "eventType": this.tuliIndex,
      //         "currentPage": 1,
      //         "pageSize": 20,
      //         "state": 0,
      //         orgId: id
      //     }
      // };
      // this.$Axios(data).then((res)=>{
      //     console.log(res);
      //     console.log('点击单位名称显示数据');
      //     console.log(res.data.data.length);
      //     //隐藏报警消息列表的数据，显示这里返回的数据
      // });
    },
    addMarkerFun(data) {
      console.log(1860, data);
      //这里全部替换为海量点
      let data0 = data.fireData;
      let data1 = data.alarmData;
      let data2 = data.faultData;
      let data3 = data.normalData;
      let data4 = data.offLineData;
      let data5 = data.warningData;

      let that = this;
      this.labelMarkerArr = [];
      let labelMarkerArr = [];
      //灵活点标记
      var zoomStyleMapping = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
      };
      let arr = [];

      for (let i = 0; i < data0.length; i++) {
        //火警图标 marker1Img
        if (data0[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data0[i].value[0], data0[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              type: "image",
              image: marker1Img,
              size: [20, 30],
              anchor: "center",
            },
            extData: {
              pos: [data0[i].value[0], data0[i].value[1]],
              name: data0[i].name,
              // data: data0[i].value[2],
              orgId: data0[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
          // console.log(data0[i].value);
        }
      }

      for (let i = 0; i < data1.length; i++) {
        //报警图标 marker0Img
        if (data1[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data1[i].value[0], data1[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: "image",
              // 图片 url
              image: marker0Img,
              // 图片尺寸
              size: [20, 30],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: "center",
            },
            extData: {
              pos: [data1[i].value[0], data1[i].value[1]],
              name: data1[i].name,
              // data: data1[i].value[2],
              orgId: data1[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
          // console.log(data1[i].value);
        }
      }
      // 故障 marker2Img
      for (let i = 0; i < data2.length; i++) {
        if (data2[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data2[i].value[0], data2[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: "image",
              // 图片 url
              image: marker2Img,
              // 图片尺寸
              size: [20, 30],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: "center",
            },
            extData: {
              pos: [data2[i].value[0], data2[i].value[1]],
              name: data2[i].name,
              // data: data2[i].value[2],
              orgId: data2[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
          // console.log(data2[i].value);
        }
      }
      //正常 marker3Img
      let data3_length = data3.length;
      for (let i = 0; i < data3_length; i++) {
        if (data3[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data3[i].value[0], data3[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: "image",
              // 图片 url
              image: marker3Img,
              // 图片尺寸
              size: [20, 30],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: "center",
            },
            extData: {
              pos: [data3[i].value[0], data3[i].value[1]],
              name: data3[i].name,
              // data: data3[i].value[2],
              orgId: data3[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
          // console.log(data3[i].value);
        }
      }
      //未联网 marker4Img
      let data4_length = data4.length;
      for (let i = 0; i < data4_length; i++) {
        if (data4[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data4[i].value[0], data4[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: "image",
              // 图片 url
              image: marker4Img,
              // 图片尺寸
              size: [20, 30],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: "center",
            },
            extData: {
              pos: [data4[i].value[0], data4[i].value[1]],
              name: data4[i].name,
              // data: data4[i].value[2],
              orgId: data4[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
        }
      }
      //预警 marker5Img
      for (let i = 0; i < data5.length; i++) {
        if (data5[i].value.length >= 2) {
          let labelMarker = new AMap.LabelMarker({
            position: [data5[i].value[0], data5[i].value[1]],
            zIndex: 16,
            // 将第一步创建的 icon 对象传给 icon 属性
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: "image",
              // 图片 url
              image: marker5Img,
              // 图片尺寸
              size: [20, 30],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: "center",
            },
            extData: {
              pos: [data5[i].value[0], data5[i].value[1]],
              name: data5[i].name,
              // data: data5[i].value[2],
              orgId: data5[i].orgId,
            },
          });
          labelMarker.on("click", function() {
            // console.log(this.getExtData());
            that.markerClickStatus = true;
            that.fx_z_index = 11;
            that.depart_wrap_index = 11;
            that.company_list_index = 11;
            that.layer_wrap_index = 11;
            that.base_index = 150;
            that.nativeLayer(
              this.getExtData().pos,
              this.getExtData().name,
              this.getExtData().data,
              this.getExtData().orgId,
            );
          });
          labelMarkerArr.push(labelMarker);
        } else {
        }
      }
      this.labelsLayer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
        // 该层内标注是否避让
        collision: false,
        // 设置 allowCollision：true，可以让标注避让用户的标注
        allowCollision: false,
      });
      this.labelsLayer.add(labelMarkerArr);
      this.labelMarkerArr = labelMarkerArr;
      that.map.add(this.labelsLayer);
      // that.map.setFitView('','','',16);
    },
    setMarkerPointer(data) {
      let _renderClusterMarker = function(context) {
        let div = document.createElement("div");
        div.innerHTML = context.count;
        div.style.fontSize = "14px";

        div.style.textAlign = "center";
        let alarmData = false;
        let faultData = false;
        let fireData = false;
        let normalData = false;
        let offLineData = false;
        let warningData = false;
        for (let key of context.markers) {
          //alarmData 报警 faultData 故障 fireData 火警 normalData 正常 offLineData 离线 warningData 预警
          if (key.w.extData.type == "alarmData") {
            alarmData = true;
          }
          if (key.w.extData.type == "faultData") {
            faultData = true;
          }
          if (key.w.extData.type == "fireData") {
            fireData = true;
          }
          if (key.w.extData.type == "normalData") {
            normalData = true;
          }
          if (key.w.extData.type == "offLineData") {
            offLineData = true;
          }
          if (key.w.extData.type == "warningData") {
            warningData = true;
          }
        }
        if (offLineData) {
          div.style.backgroundImage = "url('" + marker4 + "')";
        } else if (fireData) {
          div.style.backgroundImage = "url('" + marker1 + "')";
          div.style.color = "#f3f3f3";
        } else if (alarmData) {
          div.style.backgroundImage = "url('" + marker0 + "')";
          div.style.color = "#f3f3f3";
        } else if (warningData) {
          div.style.backgroundImage = "url('" + marker5 + "')";
          div.style.color = "#f3f3f3";
        } else if (faultData) {
          div.style.backgroundImage = "url('" + marker2 + "')";
        } else {
          div.style.backgroundImage = "url('" + marker3 + "')";
        }
        div.style.width = "40px";
        div.style.height = "40px";
        div.style.lineHeight = "40px";
        div.style.backgroundSize = "100% 100%";
        context.marker.setContent(div);
      };
      let markers = [];
      var iconFun = (icon) => {
        var startIcon = new AMap.Icon({
          size: new AMap.Size(20, 30),
          image: icon,
          imageSize: new AMap.Size(20, 30),
        });
        return startIcon;
      };
      for (let key in data) {
        if (data[key].length > 0) {
          for (let i = 0; i < data[key].length; i++) {
            let mark = new AMap.Marker({
              position: data[key][i].value,
              icon:
                key == "alarmData"
                  ? iconFun(marker0Img)
                  : key == "faultData"
                  ? iconFun(marker2Img)
                  : key == "fireData"
                  ? iconFun(marker1Img)
                  : key == "normalData"
                  ? iconFun(marker3Img)
                  : key == "offLineData"
                  ? iconFun(marker4Img)
                  : iconFun(marker5Img),
              offset: new AMap.Pixel(-15, -15),
              extData: {
                pos: [data[key][i].value[0], data[key][i].value[1]],
                type: key,
                orgId: data[key][i].orgId,
              },
            });
            mark.on("click", () => {
              this.markerClickStatus = true;
              this.fx_z_index = 11;
              this.depart_wrap_index = 11;
              this.company_list_index = 11;
              this.layer_wrap_index = 11;
              this.base_index = 150;
              this.nativeLayer(
                data[key][i].value,
                data[key][i].name,
                "",
                data[key][i].orgId,
              );
            });
            markers.push(mark);
          }
        }
      }
      this.labelMarkerArr = markers;
      this.cluster = new AMap.MarkerClusterer(this.map, markers, {
        gridSize: 100,
        maxZoom: 14,
        renderClusterMarker: _renderClusterMarker,
      });
    },

    /** 地图标点 */
    setMarkerPointerLeft(data) {
      var iconFun = (icon) => {
        var startIcon = new AMap.Icon({
          size: new AMap.Size(28, 30),
          image: icon,
          imageSize: new AMap.Size(28, 30),
        });
        return startIcon;
      };
      let that = this;
      data.forEach((item) => {
        let pos = item.position.split(",");
        let img = markerImgLeft1;
        switch (item.type.toString()) {
          case "1":
            img = markerImgLeft1;
            break;
          case "2":
            img = markerImgLeft2;
            break;
          case "3":
            img = markerImgLeft3;
            break;
          case "4":
            img = markerImgLeft4;
            break;
          case "5":
            img = markerImgLeft5;
            break;
          case "6":
            img = markerImgLeft6;
            break;
          case "7":
            img = markerImgLeft7;
            break;
        }
        let marker = new AMap.Marker({
          position: new AMap.LngLat(pos[0], pos[1]),
          icon: iconFun(img),
          map: that.map,
          offset: new AMap.Pixel(-15, -15),
          extData: {
            id: item.id,
            type: item.type,
          },
        });
        marker.on("click", (e) => {
          const data = e.target.getExtData();
          that.openInfoWindow(e, data);
        });
      });
    },
    openInfoWindow(e, i) {
      var data = {
        type: "get",
        url: tubiaoInitLeftDetail,
        obj: {
          id: i.id,
          type: i.type,
        },
      };
      this.$Axios(data).then((res) => {
        if (res.data.data) {
          let datas = res.data.data;
          let name = datas.name || "";
          let winInfo = "<div class='title1'>" + name + "</div>";
          if (datas.address) {
            winInfo =
              winInfo + "<div class='info2'>地址：" + datas.address + "</div>";
          }
          if (datas.dutyPhone) {
            winInfo =
              winInfo +
              "<div class='info2'>值班电话：" +
              datas.dutyPhone +
              "</div>";
          }
          if (datas.personLiable) {
            winInfo =
              winInfo +
              "<div class='info2'>负责人：" +
              datas.personLiable +
              "</div>";
          }
          if (datas.phone) {
            winInfo =
              winInfo +
              "<div class='info2'>联系方式：" +
              datas.phone +
              "</div>";
          }
          if (datas.chargePerson) {
            winInfo =
              winInfo +
              "<div class='info2'>负责人：" +
              datas.chargePerson +
              "</div>";
          }
          if (datas.modality) {
            winInfo =
              winInfo +
              "<div class='info2'>出入口形式：" +
              datas.modality +
              "</div>";
          }
          if (datas.categoryTypeName) {
            winInfo =
              winInfo +
              "<div class='info2'>类别：" +
              datas.categoryTypeName +
              "</div>";
          }
          if (datas.waterSourceTypeName) {
            winInfo =
              winInfo +
              "<div class='info2'>类型：" +
              datas.waterSourceTypeName +
              "</div>";
          }
          if (datas.gasStationName) {
            winInfo =
              winInfo +
              "<div class='info2'>类型：" +
              datas.gasStationName +
              "</div>";
          }
          if (datas.important) {
            winInfo =
              winInfo +
              "<div class='info2'>主要成分：" +
              datas.important +
              "</div>";
          }
          if (datas.refugeLevelName) {
            winInfo =
              winInfo +
              "<div class='info2'>级别：" +
              datas.refugeLevelName +
              "</div>";
          }
          if (datas.refugeName) {
            winInfo =
              winInfo +
              "<div class='info2'>类型：" +
              datas.refugeName +
              "</div>";
          }
          if (datas.galleryful) {
            winInfo =
              winInfo +
              "<div class='info2'>容纳人数：" +
              datas.galleryful +
              "</div>";
          }
          if (datas.heightLimit) {
            winInfo =
              winInfo +
              "<div class='info2'>限高(m)：" +
              datas.heightLimit +
              "</div>";
          }
          if (datas.filePath) {
            winInfo =
              winInfo +
              "<div class='info2'>图片：<img src=" +
              datas.filePath +
              " style='width:100px;margin-bottom:10px'></img></div>";
          }
          const infoWindow = new AMap.InfoWindow({
            content: winInfo, // 自定义窗体的内容，支持HTML
            offset: new AMap.Pixel(0, -30), // 设置窗体偏移量，使其在标记上方显示
          });
          infoWindow.open(this.map, e.target.getPosition()); // 在点击的标记位置打开信息窗体
        }
      });
    },
    nativeLayer(pos, name, data, orgId) {
      // let res = data.split('_');
      this.$store.commit("baseInfoLayer", {
        detailStatus: true,
        baseInfoId: orgId,
        baseInfoItem: {
          name: name,
          position: pos[0] + "," + pos[1],
          // leader: res[5],
          // leaderPhone: res[6],
          // fireCustodianName: res[9] == 'null' ? null : res[9],
          // fireCustodianPhone: res[10] == 'null' ? null : res[10],
          // certificateNum: res[13],
          // industryCategoryName: res[2],
          // areaName: res[11],
          // address: res[1],
          // supervisionLevelCode: res[12],
        },
      });
    },
    videoClick(type) {
      this.showVideo2 = false;
      if (type == "next") {
        this.videoIndex++;
      } else {
        this.videoIndex--;
      }
      this.videoSrc = this.camerasList[this.videoIndex].hlsAddr;
      this.videoDeviceId = this.camerasList[this.videoIndex].id;
      this.channelNum = this.camerasList[this.videoIndex].channelNum;
      this.videoSid = this.camerasList[this.videoIndex].num;
      this.videoName = this.camerasList[this.videoIndex].name;
      setTimeout(() => {
        this.showVideo2 = true;
      }, 300);
    },
    closeIf() {
      this.isShowIf = false;
    },
    closeUpDate() {
      this.$refs.bottomListRefs.consoleClosed();
      this.remoteControlStatus = false;
    },
    policeSituationHandling(activeItem) {
      let index = 0;
      if (activeItem.type == "107") {
        index = 0;
      } else if (activeItem.type == "100") {
        index = 1;
      }
      this.$refs.bottomListRefs.setMarker(activeItem, index);
      this.closeInfoLayer();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .amap-info-content {
  padding: 0;
}
/deep/ .bottom-center .amap-info-sharp {
  display: none;
}
.map-iframe {
  position: absolute;
  left: 0;
  top: 87px;
  width: 100%;
  height: 94%;
  z-index: 200;
}
.close_If {
  position: absolute;
  right: 70px;
  top: 100px;
  z-index: 207;
  cursor: pointer;
}
.close-iframe {
  position: absolute;
  right: 80px;
  top: 102px;
  width: 20px;
  cursor: pointer;
}
.frame {
  position: absolute;
  left: 0;
  top: 87px;
  width: 100%;
  height: 94%;
}
#mask {
  width: 100%;
  height: 100vh;
  /*background-color: rgba(225,225,225,0); !* 浏览器不支持的时候显示 *!*/
  /*background-image: radial-gradient(rgba(225,225,225,0) 10%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.9) 100%);*/
  background-image: url("../../src/assets/img/home_bg.png");
  background-size: cover;
  background-position: 50%;
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
#mask.active {
  opacity: 0;
}
.map_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 1);
  .show_layer_btn {
    position: fixed;
    left: 0;
    top: 50%;
    transform: translate(-60%, -50%);
    z-index: 100;
    color: #74d9ff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    background: rgba(216, 216, 216, 0.25);
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translate(-50%, -50%);
      background: rgba(216, 216, 216, 0.55);
    }
    i {
      margin-right: 5px;
    }
  }
  .map_layer {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgb(0, 0, 12);
    z-index: 1;
  }
  #map {
    height: 100%;
    width: 100%;
  }
  @-webkit-keyframes opac {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.5;
    }
  }
  .infoLayer {
    position: absolute;
    left: 50%;
    bottom: 50%;
    margin-left: -222.5px;
    margin-bottom: -190px;
    transform-origin: left top 0;

    z-index: 165;
    .infoLayer_ani {
      width: 500px;
      padding: 7px 7px 10px 10px;
      box-sizing: border-box;
      border-radius: 10px;
      box-shadow: #ff0000 0px 0px 30px;
      background: -webkit-gradient(
        linear,
        0 0,
        0 bottom,
        from(#fe0e19),
        to(#6a020a)
      );
      animation: opac 5s linear infinite alternate;
    }
    .infoLayer_close_btn {
      width: 14px;
      height: 14px;
      padding: 13px;
      float: right;
      cursor: pointer;
      cursor: hand;
      position: absolute;
      right: 7px;
      top: 7px;
      z-index: 99999;
      box-sizing: content-box;
    }
    .infoLayerTitle {
      overflow: hidden;
      height: 40px;
      // line-height: 40px;
      span {
        float: left;
        font-size: 16px;
        color: #fff;
      }
    }
    .infoLayerUl {
      font-size: 16px;
      color: #fff;
      li {
        overflow: hidden;
        margin-bottom: 15px;
      }
      .infoLayerLeftName {
        float: left;
        width: 25%;
        text-align: right;
      }
      .infoLayerRightValue {
        float: left;
        width: 75%;
        text-align: left;
        word-break: break-all;
      }
      .time_li {
        .infoLayerRightValue {
          width: 280px;
          height: 8px;
          background: #fff;
          position: relative;
          margin-top: 6px;
          i.len {
            width: 55%;
            background: #fdba04;
            position: absolute;
            left: 0;
            top: 0;
            height: 8px;
            &:before {
              content: "";
              display: block;
              width: 6px;
              height: 6px;
              background-color: #fff;
              border-radius: 100%;
              position: absolute;
              right: 4px;
              top: 0;
              z-index: 3;
            }
            &:after {
              content: "";
              display: block;
              width: 14px;
              height: 14px;
              background-color: #fdba04;
              border-radius: 100%;
              position: absolute;
              right: 0;
              top: -4px;
              z-index: 2;
            }
          }
        }
      }
      .time_li:last-child {
        i.len {
          width: 35%;
          background: #1abc9c;
          &:before {
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            background-color: #fff;
            border-radius: 100%;
            position: absolute;
            right: 4px;
            top: 0;
            z-index: 3;
          }
          &:after {
            content: "";
            display: block;
            width: 14px;
            height: 14px;
            background-color: #1abc9c;
            border-radius: 100%;
            position: absolute;
            right: 0;
            top: -4px;
            z-index: 2;
          }
        }
      }
      .mb_list {
        line-height: 32px;
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        .infoLayerLeftName {
          display: block;
          float: none;
        }
        .infoLayerRightValue {
          display: block;
          float: none;
          -webkit-box-flex: 1;
          width: auto;
        }
        .mubiao_ico {
          // float: left;
          width: 150px;
          img {
            display: inline-block;
            width: 27px;
            height: 27px;
            margin-right: 15px;
            cursor: pointer;
            vertical-align: middle;
          }
        }
      }
      .dw_list {
        line-height: 32px;
        font-size: 0;
        .infoLayerLeftName {
          font-size: 16px;
        }
        .infoLayerRightValue {
          display: inline-block;
          float: none;
          width: auto;
          vertical-align: top;
          font-size: 16px;
          min-width: 213px;
        }
        .marker_dw_btn {
          display: inline-block;
          vertical-align: text-bottom;
          cursor: pointer;
        }
      }
    }
    .infolayer_dianhua_img {
      width: 46px;
      position: absolute;
      right: 15px;
      bottom: 30px;
    }
    .ico_shipin_layer,
    .ico_plan_layer,
    .ico_3d_layer {
      border-radius: 10px;
      overflow: hidden;
      .mubiao_close {
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        overflow: hidden;
        background: #337ab7;
        cursor: pointer;
        z-index: 1;
        img {
          width: 12px;
          height: 12px;
          margin: 9px;
        }
      }
    }
    .ico_shipin_layer .mubiao_close {
      background: none;
    }
    .ico_shipin_layer {
      position: absolute;
      width: 450px;
      height: 100%;
      right: -460px;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
      .video-js,
      video {
        width: 100%;
        height: 100%;
      }
      .video-js,
      .vjs-fullscreen-control {
        outline: none;
      }
    }
    .ico_plan_layer {
      position: absolute;
      width: 450px;
      height: 250px;
      left: 0;
      top: 360px;
      background: rgba(0, 0, 0, 0.8);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .ico_3d_layer {
      position: absolute;
      width: 686px;
      height: 208%;
      left: -689px;
      top: -152px;
      background: rgba(0, 0, 0, 0.8);
      iframe {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }

  .closeLayerActive {
    transition: all 0.5s ease;
    animation: scaleMo 0.5s ease;
    animation-fill-mode: forwards;
  }
  @-webkit-keyframes scaleMo {
    0% {
      transform: scale(1);
      background: rgb(254, 14, 25);
    }
    100% {
      transform: scale(0);
      background: rgb(254, 14, 25);
    }
  }
  .org_search {
    position: absolute;
    top: 70px;
    left: 40%;
    margin-left: -100px;
    width: 500px;
    height: 80px;
    z-index: 1;
    transition: all 1s;
    transform: translateX(0);
    border-radius: 5px;
    overflow: hidden;
    background-image: url("../assets/img/seachBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    input {
      display: block;
      width: 75%;
      height: 52%;
      margin-left: 112px;
      margin-top: 34px;
      border-radius: 5px;
      border: none;
      box-sizing: border-box;
      padding: 5px 10px;
      background: transparent;
      color: #fff;
      cursor: pointer;
      box-sizing: border-box;
      outline: none;
      border: none;
    }
    ::-moz-placeholder {
      color: #ffffff;
    }
    ::-webkit-input-placeholder {
      color: #ffffff;
    }
    :-ms-input-placeholder {
      color: #ffffff;
    }
  }
  .l_layer {
    position: absolute;
    top: 87px;
    right: 371px;
    width: 120px;
    height: 31px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    background: #0c2c52;
    cursor: pointer;
    z-index: 1;
    transition: all 1s;
    transform: translateX(0);

    span {
      display: block;
      font-size: 14px;
      color: #848c93;
    }
  }
  .lk_layer {
    position: absolute;
    top: 87px;
    right: 251px;
    width: 120px;
    height: 31px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    background: #0c2c52;
    cursor: pointer;
    z-index: 1;
    transition: all 1s;
    transform: translateX(0);
    img {
      display: block;
      margin-right: 5px;
      opacity: 0.5;
    }
    span {
      display: block;
      font-size: 14px;
    }
  }
  .wx_layer {
    position: absolute;
    top: 87px;
    right: 131px;
    width: 120px;
    height: 31px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    background: #0c2c52;
    cursor: pointer;
    z-index: 1;
    transition: all 1s;
    transform: translateX(0);
    img {
      display: block;
      margin-right: 5px;
      width: 15px;
      opacity: 0.5;
    }
    span {
      display: block;
      font-size: 14px;
      color: #848c93;
    }
  }
  .to3d {
    position: absolute;
    top: 87px;
    right: 11px;
    width: 120px;
    height: 31px;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    background: #0c2c52;
    cursor: pointer;
    z-index: 1;
    transition: all 1s;
    transform: translateX(0);
    img {
      display: block;
      margin-right: 5px;
      width: 15px;
      opacity: 1;
      width: 20px;
      height: 20px;
    }
    span {
      display: block;
      font-size: 14px;
    }
  }

  .trans-X {
    transform: translateX(-400px);
  }
  .l_layer.active,
  .lk_layer.active,
  .wx_layer.active {
    background: #24578c;
    img {
      opacity: 1;
    }
    span {
      color: white !important;
    }
  }

  .depart-wrap {
    width: calc(100vw - 800px);
    height: 50%;
    background: linear-gradient(
      rgba(0, 2, 4, 1),
      rgba(0, 68, 93, 1),
      rgba(0, 2, 4, 1)
    );
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .company_list {
    width: 600px;
    height: 300px;
    background: rgba(6, 18, 44, 1) url("../assets/img/maskBg.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -300px;
    margin-top: -150px;
    border-radius: 5px;
    box-sizing: border-box;
    .close_span {
      display: block;
      padding: 12px 17px;
      overflow: hidden;
      img {
        width: 16px;
        height: 16px;
        float: right;
        cursor: pointer;
      }
    }
    .tit span,
    li span {
      // color: #00ffff;
      font-size: 16px;
      line-height: 35px;
      width: 50%;
      height: 35px;

      float: left;
      text-align: center;
    }
    .tit {
      overflow: hidden;
      background: #2a5b7b;
    }
    ul {
      li {
        overflow: hidden;
        cursor: pointer;
      }
      li:first-child {
        border-top: none;
      }
    }
    .map_list_wrap {
      height: 175px;
      margin-top: 10px;
      height: 200px;
      overflow: hidden;
      li:hover {
        background-color: #0c2745;
      }
      .active {
        background: #0c2745 !important;
      }
    }

    //前往告警管理
    .more_data_wrap {
      position: absolute;
      left: 0;
      bottom: -70px;
      width: 100%;
      height: 50px;
      background: rgba(0, 68, 93, 0.8);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      box-sizing: border-box;
      font-size: 14px;
      .more_data_btn {
        .go_search {
          padding: 5px;
          background: rgba(0, 68, 93, 1);
          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
        }
        .cancel {
          background: rgba(0, 68, 93, 1);
          color: #ddd;
          padding: 5px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .report_wrap {
    position: fixed;
    width: 800px;
    height: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 10;
    .close_btn {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 14px;
      padding: 10px;
      cursor: pointer;
      box-sizing: content-box;
    }
  }
}
/deep/ .mCSB_inside > .mCSB_container {
  margin-right: 10px !important;
}
/deep/ .mCSB_scrollTools {
  right: 0 !important;
  .mCSB_dragger {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    .mCSB_dragger_bar {
      width: 8px;
    }
  }
  .mCSB_draggerRail {
    background-color: transparent;
  }
}
.video-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #fff;
  padding: 0 50px 0 20px;
  align-items: center;
  line-height: 40px;
  .video-btn {
    display: flex;
  }
}

/deep/ .title1 {
  background: #1e79d8;
  color: #fff;
  line-height: 2;
  padding-left: 5px;
  margin-bottom: 4px;
}
/deep/ .info2 {
  display: flex;
  color: #fff;
  padding: 2px 10px;
}
.remote-control {
  width: 98%;
  min-width: 1500px;
  position: absolute;
  top: 9%;
  transform: translateX(-50%);
  left: 50%;
  z-index: 99;
  background: #07132b;
  -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
  box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue